import axios from "axios";
var base64 = require('base-64');
var md5 = require('md5');
import config from "config/index";
let host = config.host+"/api/"
let apikey=config.apikey
// initializing the axios instance with custom configs
export default function () {
    let token = localStorage.getItem("token")
    let data={
    }
    return axios.post(host + `messages/list`,
    data,
        {
            headers: {
                "Content-Type": "application/json",
                "ApiKey": apikey,
                "Authorization":"Bearer "+token
            }
        }).then((response) => {
            return response.data
        }).catch((err) => {
            if (err?.response?.status == 401)
                { localStorage.removeItem("token"); window.location=("/auth/signin"); return toast.error("لطفا مجددا لاگین کنید.", {position: "bottom-right"})}
            else
            throw err;
        })
}